import { PathwayUI } from 'bland-client-js-sdk';
import { useParams } from 'react-router';

const Pathway = () => {
  const { pathwayId } = useParams();
  return (
    <div className="relative">
      Pathway
      {pathwayId && (
        <PathwayUI
          apiKey="sk-z51sbhg752nwvosodqvd1yzwh7bsnkhj5k5thch6q48z1zmgtjtbgz8gtdxpe1yr69"
          pathwayId="7f38d4bf-3bf0-4506-8ace-a77bb9cfdacc"
          style={{
            position: 'relative',
            width: '100%',
            height: '100ch',
            border: 'none',
            backgroundColor: 'transparent',
          }}
        />
      )}
    </div>
  );
};

export default Pathway;
